import { render } from "./NcrmPrivacyCompanyContactPoints.vue?vue&type=template&id=7aced40a&scoped=true"
import script from "./NcrmPrivacyCompanyContactPoints.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyCompanyContactPoints.vue?vue&type=script&lang=js"

import "./NcrmPrivacyCompanyContactPoints.vue?vue&type=style&index=0&id=7aced40a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aced40a"]])

export default __exports__